import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { selectDealFromApplication } from 'store/loanApplications/selectors';

/**
 * Returns valid loanId either from Deal or from URL params.
 * Used for Loan Editor without loanId in params
 * @returns {String}
 */
const useLoanId = () => {
  const { loanId } = useParams();

  const deal = useSelector(selectDealFromApplication);

  return loanId || deal?.loanId;
};

export default useLoanId;
